<template>
    <div class="body-pergunta">
        <b-modal ref="add-nova-etapa"
        size="md"
        centered
        title="Adicionar itens para o cabeçalho"
        :hide-footer="true"
        :no-close-on-backdrop="true"
        :no-close-on-esc="true"
        body-class="rounded-bottom-1rem "
        content-class="rounded-1rem"
        >
        <template #modal-title>
            <div class="header-title">{{subEtapa === true ? 'Adicionar Subetapa' : 'Adicionar Etapa'}}</div>
        </template>
            <div class="container-add-pergunta">
              <div v-if="subEtapa === false && Editar === false && fluxoEscolhido === null && equipamento !== true">
                <div class="container_resete" :id="tipoFluxo.avaliacao" @click="fluxoTipoEscolhido(tipoFluxo.avaliacao)">
                  <div class="d-flex corpo_componente_resete">
                      <div class="icone-reset">
                        <img class="img_tipo_campo" :src="imgAvalicao">
                      </div>
                      <div class="header-resete">
                          <div class="titulo_resetar">
                             Avaliação
                          </div>
                          <div class="subtitulo_resetar">
                              Crie uma novo lista de verificação
                          </div>
                      </div>
                  </div>
                </div>

                <div class="container_resete" :id="tipoFluxo.metadado" @click="fluxoTipoEscolhido(tipoFluxo.metadado)">
                  <div class="d-flex corpo_componente_resete">
                      <div class="icone-reset">
                        <img class="img_tipo_campo" :src="imgAnexo">
                      </div>
                      <div class="header-resete">
                          <div class="titulo_resetar">
                            Campo customizado
                          </div>
                          <div class="subtitulo_resetar">
                            Crie uma novo lista customizada
                          </div>
                      </div>
                  </div>
                </div>
              </div>

              <div class="container_cadastra_pergunta" v-if="subEtapa === true ? true : equipamento === true ? true : fluxoEscolhido !== null ? true : Editar === true ? true : false">
                <!-- Chamado #20155 (item 4, ZOP-63): a descricao da SUB-ETAPA deixou de ser
                     obrigatoria. A da ETAPA continua exigida — o asterisco so some no ramo
                     subEtapa. Pareia com a versao do app que trata descricao nullable. -->
                <label class="labelsearch margem">{{subEtapa === true ? 'Insira a descrição da Subetapa' : 'Insira a descrição da Etapa'}}
                  <span v-if="subEtapa !== true" style="color: #540000; font-weight: bold;" v-b-tooltip.hover title="Item obrigatório"> *</span>
                </label>
                <label class="infor">{{subEtapa === true ? 'Adicione o nome da Subetapa que será utilizada no agrupamento das perguntas!' : 'Adicione o nome da etapa que será utilizada no agrupamento das subetapas!'}}</label>

                <div  style="width: 100%;">
                  <b-form-textarea ref="descricaoTextarea" class="input-descricao" rows="5" v-model="novoEtapa"  :placeholder="subEtapa === true ? 'Exemplo: Geral' : 'Exemplo: Verifição de rotina'"></b-form-textarea>
                </div>

                <b-form-group
                  class="font pivs"
                  style="margin-bottom: 1rem;"
                  id="Input-group-template-pes"
                  label="Nível Prioridade"
                  label-for="input-template-pes"
                >
                  <b-form-input
                  class="input"
                  id="input-new-pes"
                  name="input-new-pes"
                  type="text"
                  v-model="formattedValueAvaliacao"
                  placeholder="Digite o níveld prioridade"
                  ></b-form-input>

                  <!-- <b-form-input
                  class="input"
                  id="input-new-pes"
                  name="input-new-pes"
                  v-if="tipometadado === true"
                  type="text"
                  v-model="formattedValue"
                  placeholder="Digite o níveld prioridade"
                  ></b-form-input> -->
                </b-form-group>

                <div class="d-flex container_cancel_save">
                    <div class="cancelar">
                        <button class="button-cancel" @click="fecharPopUptAdd">CANCELAR</button>
                    </div>
                    <div class="criar" v-if="subEtapa === false && Editar === false && EditarSub === false">
                        <button class="button-save" @click="adicionarEtapa">ADICIONAR</button>
                    </div>
                    <div class="criar" v-if="subEtapa === true && Editar === false && EditarSub === false">
                        <button class="button-save" @click="adicionarSubEtapa">ADICIONAR</button>
                    </div>
                    <div class="criar" v-if="Editar === true">
                        <button class="button-save" @click="EditarEtapa">EDITAR</button>
                    </div>
                    <div class="criar" v-if="EditarSub === true">
                        <button class="button-save" @click="EditarSubEtapa">EDITAR</button>
                    </div>

                </div>

              </div>
            </div>
        </b-modal>
    </div>
</template>

<script>
import addGroup from './addGroup'
export default addGroup
</script>
  <style scoped>
  .infor {
    margin-top: 0.5rem;
    font: normal normal 600 13px / 24px Segoe UI;
    color: #6e6e6e;
  }
  .img_tipo_campo {
    width: 80%;
  }
  .body-pergunta {
    width: 100%;
  }
  .labelsearch {
    color: #484848;
    font: normal normal 600 15px / 24px Segoe UI;
  }
  .header-title {
    color: white;
    font-weight: bold;
    font-size: 16px;
    font-family: 'Segoe UI';
  }
  .container_cadastra_pergunta{
    display: flex;
    flex-direction: column;
    padding: 0 1rem;
  }
  .input-descricao{
      width: 100%;
      margin-top: 0.5rem;
      border: 1px solid rgb(216, 216, 216);
      border-radius: 2px;
      padding-left: 17px;
      margin-bottom: 1rem;
  }
  .container_cancel_save{
    justify-content: center;
    width: 100%;
    margin-top: 3rem;
    column-gap: 20px;
   }
   .button-cancel{
     background-color: #b60000;
     color: white;
   }
   .button-save{
    background-color: darkgreen;
    color: white;
   }

  .button-cancel,
  .button-save{
    margin-top: 10;
    font-size: 12PX;
    outline: transparent;
    border: transparent;
    border-radius: 4px;
    text-transform: uppercase;
    width: 190px;
    height: 40px;
  }
  .container_resete{
    margin-top: 1rem;
    width: 100%;
    padding: 0.5rem;
    cursor: pointer;
    height: fit-content;
    border-radius: 4px;
    border: 2px solid #d7d7d7;
  }
  .container_resete.clicked {
    border: 2px solid #008144; /* Cor de fundo alterada */
  }
  .corpo_componente_resete {
    width: 100%;
    border-radius: 3px;
    padding: 0 0.5rem 0 0.5rem;
    align-items: center;
    gap: 1rem;
  }
  .icone-reset {
    width: 40px;
    height: 40px;
    font-size: 20px;
    background: rgb(203, 233, 207);
    color: rgb(28, 98, 40);
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .titulo_resetar {
    height: 20px;
    font: normal normal 700 14px/33px Segoe UI;
    color: #484848;
  }
  .subtitulo_resetar{
    font: normal normal 600 13px/33px Segoe UI;
    color: #6e6e6e;
  }
 </style>



// WEBPACK FOOTER //
// src/views/private/qma/qmaTemplate/detailsTemplate/tabsTemplate/components/TemplateDetail/GroupDetail/addGroup/addGroup.vue